import Vue from 'vue'
import VueRouter from 'vue-router'
import login from "@/views/pc/login";
//import epas from "@/views/pc/epas"; //鱼化寨、罗敷入口
// import epas from "@/views/pc/epas_xinhe.vue"; //新河
import epas from "@/views/pc/epasNewMenu"; //动态菜单


// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

export default [
    {
        path: '/',
        name: "/pc/login",
        component: login,
    },
    {
        path: '/home',
        name: '/pc/home',
        component: epas,
        meta: { requireAuth: true },
        children: [

            {
                path: '/aonthlyAnnualGoal',
                name: '/pc/aonthlyAnnualGoal',
                component: () => import('@/components/pc/aonthlyAnnualGoal/index.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/monthlyReport',
                name: '/pc/monthlyReport',
                component: () => import('@/components/pc/monthlyReport.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/archivingQuery_shanglin',
                name: '/pc/archivingQuery_shanglin',
                component: () => import('@/components/pc/archivingQuery_shanglin.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/monthlyReport_shanglin',
                name: '/pc/monthlyReport_shanglin',
                component: () => import('@/components/pc/monthlyReport_shanglin.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/gaoqiaomonthlyReport',
                name: '/pc/gaoqiaomonthlyReport',
                component: () => import('@/components/pc/gaoqiaomonthlyReport.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/monthlyReportNew',
                name: '/pc/monthlyReportNew',
                component: () => import('@/components/pc/monthlyReportNew.vue'),
                meta: { requireAuth: true }
            },

            {
                path: '/monthlyReportNew_caotan',
                name: '/pc/monthlyReportNew_caotan',
                component: () => import('@/components/pc/monthlyReportNew_caotan.vue'),
                meta: { requireAuth: true }
            },

                        {
                path: '/monthlyReportNew_dianzicheng',
                name: '/pc/monthlyReportNew_dianzicheng',
                component: () => import('@/components/pc/monthlyReportNew_dianzicheng.vue'),
                meta: { requireAuth: true }
            },

            {
                path: '/monthlyReportNew_hancheng',
                name: '/pc/monthlyReportNew_hancheng',
                component: () => import('@/components/pc/monthlyReportNew_hancheng.vue'),
                meta: { requireAuth: true }
            },

            {
                path: '/monthlyReportNew_hancheng_guidang',
                name: '/pc/monthlyReportNew_hancheng_guidang',
                component: () => import('@/components/pc/monthlyReportNew_hancheng_guidang.vue'),
                meta: { requireAuth: true }
            },

            // 工作量明细
            {
                path: '/workloadDetail',
                name: '/pc/workloadDetail',
                component: () => import('@/components/pc/workloadDetail.vue'),
                meta: { requireAuth: true }
            },

            // 质量指标
            {
                path: '/qualityIndex',
                name: '/pc/qualityIndex',
                component: () => import('@/components/pc/examine/qualityIndex/index.vue'),
                meta: { requireAuth: true }
            },

            // 质量考核
            {
                path: '/qualityAssessment',
                name: '/pc/qualityAssessment',
                component: () => import('@/components/pc/examine/qualityAssessment/index.vue'),
                meta: { requireAuth: true }
            },

            // 评价撤回
            {
                path: '/evaluationWithdrawal',
                name: '/pc/evaluationWithdrawal',
                component: () => import('@/components/pc/evaluationWithdrawal/index.vue'),
                meta: { requireAuth: true }
            },

            // 医德医风指标
            {
                path: '/medicalEthicsIndex',
                name: '/pc/medicalEthicsIndex',
                component: () => import('@/components/pc/examine/medicalEthicsIndex/index.vue'),
                meta: { requireAuth: true }
            },

            // 医德医风考核
            {
                path: '/medicalEthicsAssessment',
                name: '/pc/medicalEthicsAssessment',
                component: () => import('@/components/pc/examine/medicalEthicsAssessment/index.vue'),
                meta: { requireAuth: true }
            },

            // 质量评价
            {
                path: '/evaluate',
                name: '/pc/evaluate',
                component: () => import('@/components/pc/examine/evaluate/index.vue'),
                meta: { requireAuth: true }
            },

            // 医德医风评价
            {
                path: '/medicalEthicsEvaluate',
                name: '/pc/medicalEthicsEvaluate',
                component: () => import('@/components/pc/examine/medicalEthicsEvaluate/index.vue'),
                meta: { requireAuth: true }
            },

            // 上报撤回
            {
                path: '/reportWithdrawal',
                name: '/pc/reportWithdrawal',
                component: () => import('@/components/pc/reportWithdrawal/index.vue'),
                meta: { requireAuth: true }
            },

            {
                path: '/newMdicalEthicsEvaluate',
                name: '/pc/newMdicalEthicsEvaluate',
                component: () => import('@/components/pc/newMdicalEthics/qualityEvaluation/index.vue'),
                meta: { requireAuth: true }
            },

            {
                path: '/newMdicalEthicsProofread',
                name: '/pc/newMdicalEthicsProofread',
                component: () => import('@/components/pc/newMdicalEthics/proofread/index.vue'),
                meta: { requireAuth: true }
            },

            {
                path: '/subscribe',
                name: '/pc/subscribe',
                component: () => import('@/components/pc/consumableMaterial/subscribe/index.vue'),
                meta: { requireAuth: true }
            },

            // 耗材申购（申领预估）
            {
                path: '/consumableMaterial',
                name: '/pc/consumableMaterial',
                component: () => import('@/components/pc/consumableMaterial/subscribe/consumableMaterial.vue'),
                meta: { requireAuth: true }
            },

            {
                path: '/dutyRegistration',
                name: '/pc/dutyRegistration',
                component: () => import('@/components/pc/onDuty/dutyRegistration.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/myApproval',
                name: '/pc/myApproval',
                component: () => import('@/components/pc/myApproval.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/businessRecord',
                name: '/pc/businessRecord',
                component: () => import('@/components/pc/businessRecord.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/businessRecord_caotan',
                name: '/pc/businessRecord_caotan',
                component: () => import('@/components/pc/businessRecord_caotan.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/wisdomAccountingTemplate_one',
                name: '/pc/wisdomAccountingTemplate_one',
                component: () => import('@/components/pc/wisdomAccountingTemplate_one.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/wisdomAccountingTemplate_two',
                name: '/pc/wisdomAccountingTemplate_two',
                component: () => import('@/components/pc/wisdomAccountingTemplate_two.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/recordQuery',
                name: '/pc/recordQuery',
                component: () => import('@/components/pc/recordQuery.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/ccReport',
                name: '/pc/ccReport',
                component: () => import('@/components/pc/ccReport.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/businessOperation',
                name: '/pc/businessOperation',
                component: () => import('@/components/pc/businessOperation/index'),
                meta: { requireAuth: true }
            },

            {
                path: '/committedList',
                name: '/pc/committedList',
                component: () => import('@/components/pc/committed/list/index.vue'),
                meta: { requireAuth: true }
            },
            {
                path: '/basicArchives',
                name: '/pc/basicArchives',
                component: () => import('@/components/pc/basicArchives/index'),
                meta: { requireAuth: true }
            },
            {
                path: '/consumablesReport',
                name: '/pc/consumablesReport',
                component: () => import('@/components/pc/consumablesReport/index'),
                meta: { requireAuth: true }
            },
            {
                path: '/welcome',
                name: '/pc/welcome',
                component: () => import('@/components/pc/welcome_page/WelcomePage'),
                meta: { requireAuth: true }
            },
            // 个人工作
            {
                path: '/person_new',
                name: '/pc/person_new',
                component: () => import('@/components/pc/personal_work/new'),
                meta: { requireAuth: true }
            },
            {
                path: '/person_newCopy',
                name: '/pc/person_newCopy',
                component: () => import('@/components/pc/personal_work/newCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/person_toBeSubmitted',
                name: '/pc/person_toBeSubmitted',
                component: () => import('@/components/pc/personal_work/toBeSubmitted'),
                meta: { requireAuth: true }
            },
            {
                path: '/person_toBeSubmittedCopy',
                name: '/pc/person_toBeSubmittedCopy',
                component: () => import('@/components/pc/personal_work/toBeSubmittedCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/person_toBeReviewed',
                name: '/pc/person_toBeReviewed',
                component: () => import('@/components/pc/personal_work/toBeReviewed'),
                meta: { requireAuth: true }
            },
            {
                path: '/personal_toBeReviewedCopy',
                name: '/pc/personal_toBeReviewedCopy',
                component: () => import('@/components/pc/personal_work/toBeReviewedCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/person_rejection',
                name: '/pc/person_rejection',
                component: () => import('@/components/pc/personal_work/rejection'),
                meta: { requireAuth: true }
            },
            {
                path: '/person_rejectionCopy',
                name: '/pc/person_rejectionCopy',
                component: () => import('@/components/pc/personal_work/rejectionCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/userInfo',
                name: '/pc/userInfo',
                component: () => import('@/components/pc/userInfo'),
                meta: { requireAuth: true }
            },
            {
                path: '/updatePassword',
                name: '/pc/updatePassword',
                component: () => import('@/components/pc/updatePassword'),
                meta: { requireAuth: true }
            },
            {
                path: '/editToBeSubmitted',
                name: '/pc/editToBeSubmitted',
                component: () => import('@/components/pc/personal_work/editToBeSubmitted'),
                meta: { requireAuth: true }
            },
            {
                path: '/person_reviewed',
                name: '/pc/person_reviewed',
                component: () => import('@/components/pc/personal_work/reviewed'),
                meta: { requireAuth: true }
            },
            // 团队工作
            {
                path: '/team_new',
                name: '/pc/team_new',
                component: () => import('@/components/pc/team_work/new'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_newCopy',
                name: '/pc/team_newCopy',
                component: () => import('@/components/pc/team_work/newCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_toBeSubmitted',
                name: '/pc/team_toBeSubmitted',
                component: () => import('@/components/pc/team_work/toBeSubmitted'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_toBeSubmittedCopy',
                name: '/pc/team_toBeSubmittedCopy',
                component: () => import('@/components/pc/team_work/toBeSubmittedCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/refutationPiece',
                name: '/pc/refutationPiece',
                component: () => import('@/components/pc/refutationPiece'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_editToBeSubmitted',
                name: '/pc/team_editToBeSubmitted',
                component: () => import('@/components/pc/team_work/editToBeSubmitted'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_toBeConfirm',
                name: '/pc/team_toBeConfirm',
                component: () => import('@/components/pc/team_work/toBeConfirm'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_toBeConfirmCopy',
                name: '/pc/team_toBeConfirmCopy',
                component: () => import('@/components/pc/team_work/toBeConfirmCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_toBeReviewed',
                name: '/pc/team_toBeReviewed',
                component: () => import('@/components/pc/team_work/toBeReviewed'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_toBeReviewedCopy',
                name: '/pc/team_toBeReviewedCopy',
                component: () => import('@/components/pc/team_work/toBeReviewedCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_rejection',
                name: '/pc/team_rejection',
                component: () => import('@/components/pc/team_work/rejection'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_rejectionCopy',
                name: '/pc/team_rejectionCopy',
                component: () => import('@/components/pc/team_work/rejectionCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/team_reviewed',
                name: '/pc/team_reviewed',
                component: () => import('@/components/pc/team_work/reviewed'),
                meta: { requireAuth: true }
            },
            //部门主管部分
            //个人
            {
                path: '/individualPendingReview',
                name: '/pc/individualPendingReview',
                component: () => import('@/components/pc/personal_review/IndividualPendingReview'),
                meta: { requireAuth: true }
            },
            {
                path: '/individualPendingReviewCopy',
                name: '/pc/individualPendingReviewCopy',
                component: () => import('@/components/pc/personal_review/IndividualPendingReviewCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/personalRejection',
                name: '/pc/personalRejection',
                component: () => import('@/components/pc/personal_review/personalRejection'),
                meta: { requireAuth: true }
            },
            {
                path: '/personalReviewed',
                name: '/pc/personalReviewed',
                component: () => import('@/components/pc/personal_review/reviewed'),
                meta: { requireAuth: true }
            },
            {
                path: '/auditHistory',
                name: '/pc/auditHistory',
                component: () => import('@/components/pc/personal_review/auditHistory'),
                meta: { requireAuth: true }
            },
            {
                path: '/directorRejected',
                name: '/pc/directorRejected',
                component: () => import('@/components/pc/personal_review/directorRejected'),
                meta: { requireAuth: true }
            },
            // 团队
            {
                path: '/teamToBeReviewed',
                name: '/pc/teamToBeReviewed',
                component: () => import('@/components/pc/team_review/teamToBeReviewed'),
                meta: { requireAuth: true }
            },
            {
                path: '/teamToBeReviewedCopy',
                name: '/pc/teamToBeReviewedCopy',
                component: () => import('@/components/pc/team_review/teamToBeReviewedCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/teamReviewed',
                name: '/pc/teamReviewed',
                component: () => import('@/components/pc/team_review/teamReviewed'),
                meta: { requireAuth: true }
            },
            {
                path: '/teamRejection',
                name: '/pc/teamRejection',
                component: () => import('@/components/pc/team_review/teamRejection'),
                meta: { requireAuth: true }
            },
            {
                path: '/teamAuditHistory',
                name: '/pc/teamAuditHistory',
                component: () => import('@/components/pc/team_review/teamAuditHistory'),
                meta: { requireAuth: true }
            },
            {
                path: '/teamDirectorRejected',
                name: '/pc/teamDirectorRejected',
                component: () => import('@/components/pc/team_review/teamDirectorRejected'),
                meta: { requireAuth: true }
            },

            //主任
            {
                path: '/directorToBeApproved',
                name: '/pc/directorToBeApproved',
                component: () => import('@/components/pc/director_review/directorToBeApproved'),
                meta: { requireAuth: true }
            },
            {
                path: '/directorReviewed',
                name: '/pc/directorReviewed',
                component: () => import('@/components/pc/director_review/directorReviewed'),
                meta: { requireAuth: true }
            },
            {
                path: '/history',
                name: '/pc/history',
                component: () => import('@/components/pc/director_review/history'),
                meta: { requireAuth: true }
            },
            {
                path: '/rankingList',
                name: '/pc/rankingList',
                component: () => import('@/components/pc/director_review/rankingList'),
                meta: { requireAuth: true }
            },
            {
                path: '/directorRejected_director',
                name: '/pc/directorRejected_director',
                component: () => import('@/components/pc/director_review/directorRejected'),
                meta: { requireAuth: true }
            },
            {
                path: '/directorRejected_directorCopy',
                name: '/pc/directorRejected_directorCopy',
                component: () => import('@/components/pc/director_review/directorRejectedCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/rejectedForTrial',
                name: '/pc/rejectedForTrial',
                component: () => import('@/components/pc/director_review/rejectedForTrial'),
                meta: { requireAuth: true }
            },
            {
                path: '/staffRewardAndPunishments',
                name: '/pc/staffRewardAndPunishments',
                component: () => import('@/components/pc/director_review/staffRewardAndPunishments'),
                meta: { requireAuth: true }
            },
            {
                path: '/staffCorrection',
                name: '/pc/staffCorrection',
                component: () => import('@/components/pc/director_review/staffCorrection'),
                meta: { requireAuth: true }
            },
            {
                path: '/performance',
                name: '/pc/performance',
                component: () => import('@/components/pc/director_review/performance'),
                meta: { requireAuth: true }
            },
            {
                path: '/rewardsAndPunishments',
                name: '/pc/rewardsAndPunishments',
                component: () => import('@/components/pc/director_review/rewardsAndPunishments'),
                meta: { requireAuth: true }
            },
            {
                path: '/correction',
                name: '/pc/correction',
                component: () => import('@/components/pc/director_review/correction'),
                meta: { requireAuth: true }
            },


            //财务
            {
                path: '/finance',
                name: '/pc/finance',
                component: () => import('@/components/pc/finance/finance'),
                meta: { requireAuth: true }
            },
            {
                path: '/financeCopy',
                name: '/pc/financeCopy',
                component: () => import('@/components/pc/finance/financeCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/financeArchived',
                name: '/pc/financeArchived',
                component: () => import('@/components/pc/finance/financeArchived'),
                meta: { requireAuth: true }
            },
            {
                path: '/archiveView',
                name: '/pc/archiveView',
                component: () => import('@/components/pc/director_review/archiveView'),
                meta: { requireAuth: true }
            },
            {
                path: '/financeEnter',
                name: '/pc/financeEnter',
                component: () => import('@/components/pc/finance/financeEnter'),
                meta: { requireAuth: true }
            },
            {
                path: '/financeMaintain',
                name: '/pc/financeMaintain',
                component: () => import('@/components/pc/finance/financeMaintain'),
                meta: { requireAuth: true }
            },
            {
                path: '/financeSubmitAudit',
                name: '/pc/financeSubmitAudit',
                component: () => import('@/components/pc/finance/financeSubmitAudit'),
                meta: { requireAuth: true }
            },
            {
                path: '/financeCalculate',
                name: '/pc/financeCalculate',
                component: () => import('@/components/pc/finance/financeCalculate'),
                meta: { requireAuth: true }
            },
            {
                path: '/financeFile',
                name: '/pc/financeFile',
                component: () => import('@/components/pc/finance/financeFile'),
                meta: { requireAuth: true }
            },

            //后台
            {
                path: '/myPerformance',
                name: '/pc/myPerformance',
                component: () => import('@/components/pc/myPerformance'),
                meta: { requireAuth: true }
            },
            {
                path: '/userManage',
                name: '/pc/userManage',
                component: () => import('@/components/pc/backgroundSystem/user_manage/userManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/addUser',
                name: '/pc/addUser',
                component: () => import('@/components/pc/backgroundSystem/user_manage/addUser'),
                meta: { requireAuth: true }
            },
            {
                path: '/updateUserPassword',
                name: '/pc/updateUserPassword',
                component: () => import('@/components/pc/backgroundSystem/user_manage/updateUserPassword'),
                meta: { requireAuth: true }
            },
            {
                path: '/updateUserInfo',
                name: '/pc/updateUserInfo',
                component: () => import('@/components/pc/backgroundSystem/user_manage/userInfo'),
                meta: { requireAuth: true }
            },
            {
                path: '/permissionManage',
                name: '/pc/permissionManage',
                component: () => import('@/components/pc/backgroundSystem/permission_manage/permissionManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/editPermission',
                name: '/pc/editPermission',
                component: () => import('@/components/pc/backgroundSystem/permission_manage/editPermission'),
                meta: { requireAuth: true }
            },
            {
                path: '/memberNumberManage',
                name: '/pc/memberNumberManage',
                component: () => import('@/components/pc/backgroundSystem/permission_manage/memberNumberManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/roleManage',
                name: '/pc/roleManage',
                component: () => import('@/components/pc/backgroundSystem/role_manage/roleManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/flowManage',
                name: '/pc/flowManage',
                component: () => import('@/components/pc/backgroundSystem/flow_manage/flowManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/newFlowManage',
                name: '/pc/newFlowManage',
                component: () => import('@/components/pc/backgroundSystem/flow_manage/newFlowManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/distributePermission',
                name: '/pc/distributePermission',
                component: () => import('@/components/pc/backgroundSystem/permission_manage/distributePermission'),
                meta: { requireAuth: true }
            },
            {
                path: '/editRole',
                name: '/pc/editRole',
                component: () => import('@/components/pc/backgroundSystem/role_manage/editRole'),
                meta: { requireAuth: true }
            },
            {
                path: '/workKindManage',
                name: '/pc/workKindManage',
                component: () => import('@/components/pc/backgroundSystem/work_manage/workKindManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/workItemManage',
                name: '/pc/workItemManage',
                component: () => import('@/components/pc/backgroundSystem/work_manage/workItemManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/departManage',
                name: '/pc/departManage',
                component: () => import('@/components/pc/backgroundSystem/depart_manage/departManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/addWorkKind',
                name: '/pc/addWorkKind',
                component: () => import('@/components/pc/backgroundSystem/work_manage/addWorkKind'),
                meta: { requireAuth: true }
            },
            {
                path: '/editWorkKind',
                name: '/pc/editWorkKind',
                component: () => import('@/components/pc/backgroundSystem/work_manage/editWorkKind'),
                meta: { requireAuth: true }
            },
            {
                path: '/addWorkItem',
                name: '/pc/addWorkItem',
                component: () => import('@/components/pc/backgroundSystem/work_manage/addWorkItem'),
                meta: { requireAuth: true }
            },
            {
                path: '/editWorkItem',
                name: '/pc/editWorkItem',
                component: () => import('@/components/pc/backgroundSystem/work_manage/editWorkItem'),
                meta: { requireAuth: true }
            },
            {
                path: '/addDepart',
                name: '/pc/addDepart',
                component: () => import('@/components/pc/backgroundSystem/depart_manage/addDepart'),
                meta: { requireAuth: true }
            },
            {
                path: '/editDepart',
                name: '/pc/editDepart',
                component: () => import('@/components/pc/backgroundSystem/depart_manage/editDepart'),
                meta: { requireAuth: true }
            },
            {
                path: '/changeIconOrImage',
                name: '/pc/changeIconOrImage',
                component: () => import('@/components/pc/backgroundSystem/changeIconOrImage'),
                meta: { requireAuth: true }
            },
            {
                path: '/qualityEvaluation',
                name: '/pc/qualityEvaluation',
                component: () => import('@/components/pc/backgroundSystem/qualityEvaluation'),
                meta: { requireAuth: true }
            },
            {
                path: '/employeeReport',
                name: '/pc/employeeReport',
                component: () => import('@/components/pc/backgroundSystem/employeeReport'),
                meta: { requireAuth: true }
            },
            {
                path: '/employeeReportCopy',
                name: '/pc/employeeReportCopy',
                component: () => import('@/components/pc/backgroundSystem/employeeReportCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/personalStatistics',
                name: '/pc/personalStatistics',
                component: () => import('@/components/pc/backgroundSystem/personalStatistics'),
                meta: { requireAuth: true }
            },

            {
                path: '/myPerformanceStatistics',
                name: '/pc/myPerformanceStatistics',
                component: () => import('@/components/pc/backgroundSystem/myPerformanceStatistics'),
                meta: { requireAuth: true }
            },

            // 新合
            {
                path: '/personalStatistics_xinhe',
                name: '/pc/personalStatistics_xinhe',
                component: () => import('@/components/pc/backgroundSystem/personalStatistics_xinhe'),
                meta: { requireAuth: true }
            },
            {
                path: '/personalStatisticsCopy',
                name: '/pc/personalStatisticsCopy',
                component: () => import('@/components/pc/backgroundSystem/personalStatisticsCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/summary',
                name: '/pc/summary',
                component: () => import('@/components/pc/summary'),
                meta: { requireAuth: true }
            },

            {
                path: '/summary_xinhe',
                name: '/pc/summary_xinhe',
                component: () => import('@/components/pc/summary_xinhe'),
                meta: { requireAuth: true }
            },

            {
                path: '/personRewards',
                name: '/pc/personRewards',
                component: () => import('@/components/pc/personRewards'),
                meta: { requireAuth: true }
            },
            {
                path: '/personRewardsCopy',
                name: '/pc/personRewardsCopy',
                component: () => import('@/components/pc/personRewardsCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/teamRewards',
                name: '/pc/teamRewards',
                component: () => import('@/components/pc/teamRewards'),
                meta: { requireAuth: true }
            },
            {
                path: '/teamRewardsCopy',
                name: '/pc/teamRewardsCopy',
                component: () => import('@/components/pc/teamRewardsCopy'),
                meta: { requireAuth: true }
            },
            {
                path: '/column',
                name: '/pc/column',
                component: () => import('@/components/pc/column'),
                meta: { requireAuth: true }
            },
            {
                path: '/hospitalList',
                name: '/pc/hospitalList',
                component: () => import('@/components/pc/hospitalList'),
                meta: { requireAuth: true }
            },
            {
                path: '/moduleList',
                name: '/pc/moduleList',
                component: () => import('@/components/pc/moduleList'),
                meta: { requireAuth: true }
            },
            {
                path: '/taskRecord',
                name: '/pc/taskRecord',
                component: () => import('@/components/pc/taskRecord'),
                meta: { requireAuth: true }
            },
            {
                path: '/toDoList',
                name: '/pc/toDoList',
                component: () => import('@/components/pc/toDoList'),
                meta: { requireAuth: true }
            },
            {
                path: '/existingReport',
                name: '/pc/existingReport',
                component: () => import('@/components/pc/existingReport'),
                meta: { requireAuth: true }
            },
            {
                path: '/performanceCoefficient',
                name: '/pc/performanceCoefficient',
                component: () => import('@/components/pc/performanceCoefficient'),
                meta: { requireAuth: true }
            },
            {
                path: '/taskDistribution',
                name: '/pc/taskDistribution',
                component: () => import('@/components/pc/backgroundSystem/taskDistribution'),
                meta: { requireAuth: true }
            },

            {
                path: '/evaluationRecord',
                name: '/pc/evaluationRecord',
                component: () => import('@/components/pc/evaluationRecord'),
                meta: { requireAuth: true }
            },
            {
                path: '/taskAssignment',
                name: '/pc/taskAssignment',
                component: () => import('@/components/pc/backgroundSystem/taskAssignment'),
                meta: { requireAuth: true }
            },
            {
                path: '/inventory',
                name: '/pc/inventory',
                component: () => import('@/components/pc/backgroundSystem/inventory'),
                meta: { requireAuth: true }
            },
            {
                path: '/warehouse',
                name: '/pc/warehouse',
                component: () => import('@/components/pc/backgroundSystem/warehouse'),
                meta: { requireAuth: true }
            },
            {
                path: '/purchaseReceipt',
                name: '/pc/purchaseReceipt',
                component: () => import('@/components/pc/backgroundSystem/purchaseReceipt'),
                meta: { requireAuth: true }
            },
            {
                path: '/consumableInventory',
                name: '/pc/consumableInventory',
                component: () => import('@/components/pc/backgroundSystem/consumableInventory'),
                meta: { requireAuth: true }
            },
            {
                path: '/requisition',
                name: '/pc/requisition',
                component: () => import('@/components/pc/backgroundSystem/requisition'),
                meta: { requireAuth: true }
            },
            {
                path: '/bountyHall',
                name: '/pc/bountyHall',
                component: () => import('@/components/pc/backgroundSystem/bountyHall'),
                meta: { requireAuth: true }
            },
            {
                path: '/teamManagement',
                name: '/pc/teamManagement',
                component: () => import('@/components/pc/teamManagement'),
                meta: { requireAuth: true }
            },
            {
                path: '/postAdministration',
                name: '/pc/postAdministration',
                component: () => import('@/components/pc/postAdministration'),
                meta: { requireAuth: true }
            },
            {
                path: '/temporaryTask',
                name: '/pc/temporaryTask',
                component: () => import('@/components/pc/backgroundSystem/temporaryTask'),
                meta: { requireAuth: true }
            },
            {
                path: '/claimTasks',
                name: '/pc/claimTasks',
                component: () => import('@/components/pc/claimTasks'),
                meta: { requireAuth: true }
            },
            {
                path: '/ipManage',
                name: '/pc/ipManage',
                component: () => import('@/components/pc/backgroundSystem/ip_manage/ipManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/addIP',
                name: '/pc/addIP',
                component: () => import('@/components/pc/backgroundSystem/ip_manage/addIP'),
                meta: { requireAuth: true }
            },
            {
                path: '/editIP',
                name: '/pc/editIP',
                component: () => import('@/components/pc/backgroundSystem/ip_manage/editIP'),
                meta: { requireAuth: true }
            },
            {
                path: '/ipWhitelistManage',
                name: '/pc/ipWhitelistManage',
                component: () => import('@/components/pc/backgroundSystem/ip_manage/ipWhitelistManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/questionBankManage',
                name: '/pc/questionBankManage',
                component: () => import('@/components/pc/backgroundSystem/questionnaire_manage/question_bank_manage/questionBankManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/evaluationDimension',
                name: '/pc/evaluationDimension',
                component: () => import('@/components/pc/backgroundSystem/questionnaire_manage/evaluationDimension'),
                meta: { requireAuth: true }
            },
            {
                path: '/addQuestion',
                name: '/pc/addQuestion',
                component: () => import('@/components/pc/backgroundSystem/questionnaire_manage/question_bank_manage/addQuestion'),
                meta: { requireAuth: true }
            },
            {
                path: '/editQuestion',
                name: '/pc/editQuestion',
                component: () => import('@/components/pc/backgroundSystem/questionnaire_manage/question_bank_manage/editQuestion'),
                meta: { requireAuth: true }
            },
            {
                path: '/templateManage',
                name: '/pc/templateManage',
                component: () => import('@/components/pc/backgroundSystem/questionnaire_manage/template_manage/templateManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/questionnaireHistory',
                name: '/pc/questionnaireHistory',
                component: () => import('@/components/pc/backgroundSystem/questionnaire_manage/questionnaireHistory'),
                meta: { requireAuth: true }
            },
            {
                path: '/generateQuestionnaire',
                name: '/pc/generateQuestionnaire',
                component: () => import('@/components/pc/backgroundSystem/questionnaire_manage/generateQuestionnaire'),
                meta: { requireAuth: true }
            },

            {
                path: '/attendManage',
                name: '/pc/attendManage',
                component: () => import('@/components/pc/wage_management/attendanceManagement/attendManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/reportAuditMage',
                name: '/pc/reportAuditMage',
                component: () => import('@/components/pc/wage_management/reportAudit/reportAuditMage'),
                meta: { requireAuth: true }
            },
            {
                path: '/currentMonthAcc',
                name: '/pc/currentMonthAcc',
                component: () => import('@/components/pc/wage_management/currentMonAcc/currentMonthAcc'),
                meta: { requireAuth: true }
            },
            {
                path: '/wageArchiveManage',
                name: '/pc/wageArchiveManage',
                component: () => import('@/components/pc/wage_management/archiveManage/wageArchiveManage'),
                meta: { requireAuth: true }
            },
            {
                path: '/infoSub',
                name: '/pc/infoSub',
                component: () => import('@/components/pc/wage_management/departSub/infoSub'),
                meta: { requireAuth: true }
            },
            {
                path: '/departMaintain',
                name: '/pc/departMaintain',
                component: () => import('@/components/pc/wage_management/departSub/departMaintain'),
                meta: { requireAuth: true }
            },
            {
                path: '/toBeAudit',
                name: '/pc/toBeAudit',
                component: () => import('@/components/pc/wage_management/manage/toBeAudit'),
                meta: { requireAuth: true }
            },
            {
                path: '/rejected',
                name: '/pc/rejected',
                component: () => import('@/components/pc/wage_management/manage/rejected'),
                meta: { requireAuth: true }
            },
            {
                path: '/audited',
                name: '/pc/audited',
                component: () => import('@/components/pc/wage_management/manage/audited'),
                meta: { requireAuth: true }
            },
            {
                path: '/basicInfomation',
                name: '/pc/userWageBasicInfoGai',
                component: () => import('@/components/pc/wage_management/userWageBasicInfoGai/basicInfomation'),
                meta: { requireAuth: true }
            },

            {
                path: '/workReporting',
                name: '/pc/workReporting',
                component: () => import('@/components/pc/newWork/workReporting'),
                meta: { requireAuth: true }
            },

            {
                path: '/overruled',
                name: '/pc/overruled',
                component: () => import('@/components/pc/newWork/overruled'),
                meta: { requireAuth: true }
            },
            {
                path: '/workRecords',
                name: '/pc/workRecords',
                component: () => import('@/components/pc/newWork/workRecords'),
                meta: { requireAuth: true }
            },
            {
                path: '/workApproval',
                name: '/pc/workApproval',
                component: () => import('@/components/pc/newWork/workApproval'),
                meta: { requireAuth: true }
            },

            {
                path: '/statisticalReport',
                name: '/pc/statisticalReport',
                component: () => import('@/components/pc/consumableMaterial/statisticalReport/index'),
                meta: { requireAuth: true }
            },

            // 入库审核
            {
                path: '/storageAudit',
                name: '/pc/storageAudit',
                component: () => import('@/components/pc/consumableMaterial/storageManagement/storageAudit'),
                meta: { requireAuth: true }
            },

            //领用审核
            {
                path: '/requisitionReview',
                name: '/pc/requisitionReview',
                component: () => import('@/components/pc/consumableMaterial/acquisitionManagement/requisitionReview'),
                meta: { requireAuth: true }
            },

            //申领预估审核
            {
                path: '/requisitionEstimateReview',
                name: '/pc/requisitionEstimateReview',
                component: () => import('@/components/pc/consumableMaterial/acquisitionManagement/requisitionEstimateReview'),
                meta: { requireAuth: true }
            },

            // 盘点审核
            {
                path: '/stocktakingAudit',
                name: '/pc/stocktakingAudit',
                component: () => import('@/components/pc/consumableMaterial/stocktakingManagement/stocktakingAudit'),
                meta: { requireAuth: true }
            },

            // 新质量评价
            {
                path: '/newQualityEvaluation',
                name: '/pc/newQualityEvaluation',
                component: () => import('@/components/pc/wisdomEvaluation/qualityEvaluation/index'),
                meta: { requireAuth: true }
            },

            // 质量评价校对
            {
                path: '/proofread',
                name: '/pc/proofread',
                component: () => import('@/components/pc/wisdomEvaluation/proofread/index'),
                meta: { requireAuth: true }
            },

            // 质量评价查询
            {
                path: '/evaluationQuery',
                name: '/pc/evaluationQuery',
                component: () => import('@/components/pc/evaluationQuery/index'),
                meta: { requireAuth: true }
            },
            // 我的自评
            {
                path: '/mySelfEvaluation',
                name: '/pc/mySelfEvaluation',
                component: () => import('@/components/pc/mySelfEvaluation/index'),
                meta: { requireAuth: true }
            },
            {
                path: '/backSelfEvaluation',
                name: '/pc/backSelfEvaluation',
                component: () => import('@/components/pc/backSelfEvaluation/index'),
                meta: { requireAuth: true }
            },
            // 医德医风查询
            {
                path: '/evaluationQuery_yideyifeng',
                name: '/pc/evaluationQuery_yideyifeng',
                component: () => import('@/components/pc/evaluationQuery_yideyifeng/index'),
                meta: { requireAuth: true }
            },
            // 高桥医德医风查询
            {
                path: '/evaluationQuery_yideyifeng/gaoqiao',
                name: '/pc/evaluationQuery_yideyifeng',
                component: () => import('@/components/pc/evaluationQuery_yideyifeng/gaoqiao'),
                meta: { requireAuth: true }
            },

            // 质量评价查询(xinhe)
            {
                path: '/evaluationQuery_xinhe',
                name: '/pc/evaluationQuery_xinhe',
                component: () => import('@/components/pc/evaluationQuery_xinhe/index'),
                meta: { requireAuth: true }
            },

            // 医德医风评价查询(xinhe)
            {
                path: '/medicalEthics_xinhe',
                name: '/pc/medicalEthics_xinhe',
                component: () => import('@/components/pc/medicalEthics_xinhe/index'),
                meta: { requireAuth: true }
            },
            // 医德医风评价查询(gaoqiao)
            {
                path: '/medicalEthics_gaoqiao',
                name: '/pc/medicalEthics_gaoqiao',
                component: () => import('@/components/pc/medicalEthics_gaoqiao/index'),
                meta: { requireAuth: true }
            },
            // 我的评价结果
            {
                path: '/myVerdict',
                name: '/pc/myVerdict',
                component: () => import('@/components/pc/myVerdict/index'),
                meta: { requireAuth: true }
            },

            // 我的动态质量评价结果
            {
                path: '/dynamicQuality',
                name: '/pc/dynamicQuality',
                component: () => import('@/components/pc/dynamicQuality/index'),
                meta: { requireAuth: true }
            },

            // 工作项汇总
            {
                path: '/workloadSummary',
                name: '/pc/workloadSummary',
                component: () => import('@/components/pc/workloadSummary/index'),
                meta: { requireAuth: true }
            },

            // 考核管理
            {
                path: '/assessmentManagement',
                name: '/pc/assessmentManagement',
                component: () => import('@/components/pc/assessmentIndicator/assessmentManagement/index.vue'),
                meta: { requireAuth: true }
            },

            // 科室考核绩效统计
            {
                path: '/departmentPerformanceStatistics',
                name: '/pc/departmentPerformanceStatistics',
                component: () => import('@/components/pc/assessmentIndicator/departmentPerformanceStatistics/index.vue'),
                meta: { requireAuth: true }
            },

            // 个人考核绩效统计
            {
                path: '/personalPerformanceStatistics',
                name: '/pc/personalPerformanceStatistics',
                component: () => import('@/components/pc/assessmentIndicator/personalPerformanceStatistics/index.vue'),
                meta: { requireAuth: true }
            },

        ],
    },
    //主任大数据仪表板
    // {
    //     path: '/dashBoard',
    //     name: '/pc/dashBoard',
    //     component: () => import('@/components/pc/director_review/dashBoard'),
    //     meta: { requireAuth: true }
    // },

    {
        path: '/dashBoard',
        name: '/pc/dashBoard',
        component: () => import('@/components/pc/director_review/dashBoardCopy'),
        meta: { requireAuth: true }
    },

    //单独大数据仪表板
    {
        path: '/watchDashboard',
        name: '/pc/watchDashboard',
        component: () => import('@/components/pc/dashboard/dashBoard'),
        meta: { requireAuth: true }
    }
]

